module.exports = __webpack_public_path__ + "img/jm.298755cc.svg";